// Burch Lane Designs — shared interactions
// Vanilla JS, no dependencies. Safe to drop into a Shopify theme's assets folder
// and reference these same data-attributes/classes in your Liquid templates.

document.addEventListener('DOMContentLoaded', function () {

  // ---- mobile nav toggle ----
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.querySelector('.mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('open');
      var expanded = menu.classList.contains('open');
      toggle.setAttribute('aria-expanded', expanded);
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  // ---- quantity steppers ----
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var max = parseInt(input.max || '99', 10);
    stepper.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value || '1', 10);
        val = btn.dataset.step === 'up' ? Math.min(max, val + 1) : Math.max(min, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  // ---- variant pill selection ----
  document.querySelectorAll('.variant-options').forEach(function (group) {
    group.querySelectorAll('.variant-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        group.querySelectorAll('.variant-opt').forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
      });
    });
  });

  // ---- forms with no backend yet: prevent a dead-end submit, show a confirmation ----
  document.querySelectorAll('form[data-demo-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var note = form.querySelector('.form-confirm');
      if (note) { note.style.display = 'block'; }
      form.reset();
    });
  });

});
